import React, { memo } from "react";
import { AlertCircle } from "lucide-react";

export const TeamError = memo(({ error }) => (
  <div className="relative min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 overflow-hidden">
    <div className="relative z-10 flex items-center justify-center min-h-screen">
      <div className="bg-white/70 backdrop-blur-lg border border-white/20 rounded-2xl shadow-xl p-8 max-w-md">
        <div className="flex items-center gap-3 mb-3">
          <AlertCircle className="w-5 h-5 text-red-500" />
          <h3 className="text-lg font-semibold text-red-800">Error Loading Team</h3>
        </div>
        <p className="text-red-600">{error}</p>
      </div>
    </div>
  </div>
));

TeamError.displayName = "TeamError";

